import axios from "axios";
import { hardBaseUrl } from "services/urlConstant";

const getAuthHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

/**
 * 1. Process DSRF
 * POST — Process DSRF — {{baseUrl}}/dsrf/process
 */
export const processDSRF = payload =>
  axios.post(`${hardBaseUrl}/dsrf/process`, payload, {
    headers: getAuthHeaders(),
  });

/**
 * 2. Process DSRF Apple Music
 * POST — Process DSRF Apple Music — {{baseUrl}}/dsrf/process/apple-music
 */
export const processDSRFAppleMusic = payload =>
  axios.post(`${hardBaseUrl}/dsrf/process/apple-music`, payload, {
    headers: getAuthHeaders(),
  });

/**
 * 3. DSRF Monitoring Datatable
 * GET — DSRF Monitoring Datatable — {{baseUrl}}/dsrf/monitoring/datatable?page=1&size=10&search=
 */
export const getDSRFMonitoringDatatable = (params = {}) =>
  axios.get(`${hardBaseUrl}/dsrf/monitoring/datatable`, {
    headers: getAuthHeaders(),
    params: {
      page: params.page || 1,
      size: params.size || 10,
      search: params.search || "",
      ...params,
    },
  });

/**
 * 4. DSRF Monitoring Detail
 * GET — DSRF Monitoring Detail — {{baseUrl}}/dsrf/monitoring/detail/101
 */
export const getDSRFMonitoringDetail = id =>
  axios.get(`${hardBaseUrl}/dsrf/monitoring/detail/${id}`, {
    headers: getAuthHeaders(),
  });

/**
 * 5. Retry Failed DSRF Batches
 * POST — Retry Failed DSRF Batches — {{baseUrl}}/dsrf/retry-failed-batches
 */
export const retryFailedDSRFBatches = (payload = {}) =>
  axios.post(`${hardBaseUrl}/dsrf/retry-failed-batches`, payload, {
    headers: getAuthHeaders(),
  });

/**
 * 6. Restart DSRF Process
 * POST — Restart DSRF Process — {{baseUrl}}/dsrf/restart
 */
export const restartDSRFProcess = (payload = {}) =>
  axios.post(`${hardBaseUrl}/dsrf/restart`, payload, {
    headers: getAuthHeaders(),
  });

/**
 * 7. List DSP
 * GET — List DSP — {{baseUrl}}/dsrf/list-dsp?page=1&size=10
 */
export const getListDSP = (params = {}) =>
  axios.get(`${hardBaseUrl}/dsrf/list-dsp`, {
    headers: getAuthHeaders(),
    params: {
      page: params?.page || 1,
      size: params?.size || 10,
      ...params,
    },
  });

/**
 * 8. List Period DSRF
 * GET — List Period DSRF — {{baseUrl}}/dsrf/list-period?dsp_folder_name=SPOTIFY&page=1&size=10
 */
export const getListPeriodDSRF = (params = {}) => {
  const query =
    typeof params === "string" ? { dsp_folder_name: params } : params;
  return axios.get(`${hardBaseUrl}/dsrf/list-period`, {
    headers: getAuthHeaders(),
    params: {
      dsp_folder_name: query?.dsp_folder_name,
      page: query?.page || 1,
      size: query?.size || 10,
      ...query,
    },
  });
};

/**
 * 9. List Files DSRF
 * GET — List Files DSRF — {{baseUrl}}/dsrf/list-files?dsp_folder_name=SPOTIFY&period_folder_name=2026-01&search=&is_reprocess=false&page=1&size=10
 */
export const getListFilesDSRF = (params = {}) =>
  axios.get(`${hardBaseUrl}/dsrf/list-files`, {
    headers: getAuthHeaders(),
    params: {
      dsp_folder_name: params?.dsp_folder_name,
      period_folder_name: params?.period_folder_name,
      search: params?.search || "",
      is_reprocess:
        params?.is_reprocess !== undefined ? params.is_reprocess : false,
      page: params?.page || 1,
      size: params?.size || 10,
      ...params,
    },
  });

/**
 * 10. Confirm Finish DSRF Process
 * POST — Confirm Finish DSRF Process — {{baseUrl}}/dsrf/confirm-finish
 */
export const confirmFinishDSRFProcess = (payload = {}) =>
  axios.post(`${hardBaseUrl}/dsrf/confirm-finish`, payload, {
    headers: getAuthHeaders(),
  });

/**
 * 11. Resume DSRF Process
 * POST — Resume DSRF Process — {{baseUrl}}/dsrf/resume
 */
export const resumeDSRFProcess = (payload = {}) =>
  axios.post(`${hardBaseUrl}/dsrf/retry-failed-batches`, payload, {
    headers: getAuthHeaders(),
  });

/**
 * 12. Admin Potential Claim - List DSPs
 * GET — List DSPs — {{baseUrl}}/admin/potential-claim/dsps?page=1&size=10&search=
 */
export const getAdminPotentialClaimDSPs = (params = {}) =>
  axios.get(`${hardBaseUrl}/admin/potential-claim/dsps`, {
    headers: getAuthHeaders(),
    params: {
      page: params?.page || 1,
      size: params?.size || 10,
      search: params?.search || "",
      ...params,
    },
  });

/**
 * 13. Admin Potential Claim - List DSRF Reports
 * GET — List DSRF Reports — {{baseUrl}}/admin/potential-claim/dsrf-reports?dsp_id=2&start_date=2024-01-01&end_date=2024-12-31&page=1&size=10
 */
export const getAdminPotentialClaimDSRFReports = (params = {}) =>
  axios.get(`${hardBaseUrl}/admin/potential-claim/dsrf-reports`, {
    headers: getAuthHeaders(),
    params: {
      page: params?.page || 1,
      size: params?.size || 10,
      ...params,
    },
  });

/**
 * 14. Admin Potential Claim - Process Potential Claim
 * POST — Process Potential Claim — {{baseUrl}}/admin/potential-claim/process
 */
export const processAdminPotentialClaim = (payload = {}) =>
  axios.post(`${hardBaseUrl}/admin/potential-claim/process`, payload, {
    headers: getAuthHeaders(),
  });

/**
 * 15. Admin Potential Claim - Detail DSRF Report
 * GET — Detail DSRF Report — {{baseUrl}}/admin/potential-claim/dsrf-reports/{{key}}
 */
export const getAdminPotentialClaimDSRFReportDetail = key =>
  axios.get(`${hardBaseUrl}/admin/potential-claim/dsrf-reports/${key}`, {
    headers: getAuthHeaders(),
  });
